/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import { useSelector } from "react-redux";
import { basicDialogSelector, confirmDialogSelector, isLoadingStatusSelector } from "../../../store/helpers/helperSelectors";
import { DIALOGOPENFOR } from "../../../globals/globals";
import { selectedDeviceSelector } from "../../../store/api/devices/selectors";
import RemScanModal from "./RemScanModal";
import { IFullDeviceDetails } from "../../../store/api/deviceConfig/types";
import { fabSxProps } from "../helpers";
import { useRemScanData } from "./hooks";
import { selectProfilePermissionsSelector } from "../../../store/api/auth/selectors";
import ProfilePermissions from "../../../utils/ProfilePermissions";
import { Badge } from "../../ui/badge";
import { Button } from "../../ui/button";
import { Loader2 } from "lucide-react";

const CommissioningGrid: React.FC = () => {
  const basicDialogOpenFor = useSelector(basicDialogSelector);
  const openConfirmDialog = useSelector(confirmDialogSelector);
  const selectedDevice: IFullDeviceDetails = useSelector(selectedDeviceSelector);
  const isLoadingStatus = useSelector(isLoadingStatusSelector);
  const { zoneOption, remScanClickHandler } = useRemScanData();
  const permissions: ProfilePermissions | null = useSelector(selectProfilePermissionsSelector);

  return (
    <>
      {basicDialogOpenFor === DIALOGOPENFOR.REMSCANSTART && <RemScanModal zoneOption={zoneOption} />}
      {openConfirmDialog === DIALOGOPENFOR.REMSCANSTOP && <RemScanModal />}

      <div className="grid grid-cols-[auto_1fr_auto] items-center w-full px-4 py-3 rounded-md transition-colors duration-200 hover:bg-muted">

        {/* Left */}
        <div>
          <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-[#dbeafe] dark:bg-[#1d2e54]">
            <span className="flex items-center justify-center h-5 w-5 rounded-full bg-[#c5d2e4] dark:bg-[#344365] text-primary dark:text-[#38BDF8] text-sm font-medium">
              3
            </span>
            <span className="text-sm font-medium text-primary dark:text-[#38BDF8]">
              Start Rem Scan
            </span>
          </div>
        </div>

        {/* Center */}
        <div className="flex justify-center text-sm">
          <span className="text-muted-foreground">Status:&nbsp;</span>
          <span className="text-foreground">
            {selectedDevice?.remScanActive ? "Active" : "Idle"}
          </span>
        </div>

        <div className="flex justify-end">
          {permissions?.hasOpCodeGroup("manage_sn") && (
            <>
              {selectedDevice?.remScanActive ? (
                <Button
                  onClick={remScanClickHandler}
                  variant="outline"
                  size="sm"
                  disabled={isLoadingStatus["remScan"]}
                >
                  {isLoadingStatus["remScan"] && (
                    <Loader2 className="h-4 w-4 animate-spin mr-1" />
                  )}
                  Stop
                </Button>
              ) : (
                <Button
                  onClick={remScanClickHandler}
                  variant="outline"
                  size="sm"
                  disabled={isLoadingStatus["remScan"]}
                >
                  {isLoadingStatus["remScan"] && (
                    <Loader2 className="h-4 w-4 animate-spin mr-1" />
                  )}
                  Start
                </Button>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default CommissioningGrid;
